import React from "react";
import { MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBIcon, MDBNavbarItem, MDBNavbarLink } from "mdb-react-ui-kit";
import "./CubeWorkspaceMenu.css";

export function findActiveCubeAction(areas, pathname, search = "") {
  const current = pathname + search;
  for (const area of areas || []) {
    const exact = (area.actions || []).find((action) => action.url === current);
    if (exact) return { area, action: exact };
  }
  for (const area of areas || []) for (const action of area.actions || []) {
    if (action.matchPrefix && pathname.startsWith(action.matchPrefix)) return { area, action };
  }
  return null;
}

export default function CubeWorkspaceMenu({ areas, pathname, search, onNavigate }) {
  const active = findActiveCubeAction(areas, pathname, search);
  return <div className="cube-workspace-navbar" role="navigation" aria-label="Áreas de Cuberite">
    {(areas || []).map((area) => {
      const areaActive = active?.area.key === area.key;
      if (area.actions.length === 1) return <MDBNavbarItem key={area.key}>
        <MDBNavbarLink active={areaActive} role="button" tabIndex={0} title={area.help} aria-describedby={`cube-area-help-${area.key}`} aria-current={areaActive ? "page" : undefined}
          onClick={() => onNavigate(area.actions[0].url)} onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") { event.preventDefault(); onNavigate(area.actions[0].url); }
          }}>
          <MDBIcon fas icon={area.icon} className="me-1" />{area.label}
        </MDBNavbarLink><span id={`cube-area-help-${area.key}`} className="visually-hidden">{area.help}</span>
      </MDBNavbarItem>;
      return <MDBDropdown key={area.key} className={`cube-workspace-dropdown${areaActive ? " active" : ""}`}>
        <MDBDropdownToggle tag="button" className="nav-link cube-workspace-toggle" color="none" title={area.help} aria-describedby={`cube-area-help-${area.key}`}>
          <MDBIcon fas icon={area.icon} className="me-1" />{area.label}
        </MDBDropdownToggle>
        <span id={`cube-area-help-${area.key}`} className="visually-hidden">{area.help}</span>
        <MDBDropdownMenu appendToBody={false} responsive="lg-start" className="cube-workspace-dropdown-menu">
          {area.actions.map((action) => <MDBDropdownItem key={action.key}>
            <button type="button" className={`dropdown-item${active?.action.key === action.key ? " active" : ""}`}
              aria-current={active?.action.key === action.key ? "page" : undefined} onClick={() => onNavigate(action.url)}>{action.label}</button>
          </MDBDropdownItem>)}
        </MDBDropdownMenu>
      </MDBDropdown>;
    })}
  </div>;
}
